<div class="modal fade modal--alert" id="images-of-damage-modal" tabindex="-1" role="dialog"
  aria-labelledby="images-of-damage-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading modal-alert__heading--flush">
        <div class="container">
          <button class="modal-alert__close" (click)="cancelChanges()">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <h3 class="font-normal mb-30 mt-50 mt-md-20" id="images-of-damage-modal-title"
          [innerHTML]="damageQuestion?.header_copy"></h3>
          @if (damageQuestion?.side === 'other') {
            <div class="form-group mb-30">
              <label class="mb-15">Name the damaged area</label>
              <input type="text" class="form-control placeholder-shown" id="other-area"
                placeholder="Enter damage area name">
              </div>
            }
            <div class="form-group mb-30">
              <label class="mb-15">Upload images or videos</label>
              @if (false) {
                <div class="note note--sm note--info mb-15 mb-md-20">
                  <div class="note__icon">
                    <svg class="icon">
                      <use xlink:href="#info-small"></use>
                    </svg>
                  </div>
                  <!--<div class="note__content">
                  <p>Note on what to take images of lorem ipsum dolor sit amet.</p>
                </div>-->
              </div>
            }
            <div class="custom-upload custom-upload--media dz-clickable" id="{{uniqueId}}">
              <div class="custom-upload__dropzone dz-default">
                <div class="custom-upload__thumb">
                  <img src="assets/img/upload.svg">
                </div>
                <div class="custom-upload__instructions">
                  <p>Tap to add files</p>
                  <svg class="icon">
                    <use xlink:href="#upload"></use>
                  </svg>
                  <p>Drag &amp; drop files here or <strong>browse</strong></p>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="mb-15">Add a note (optional)</label>
            <textarea
              id="upload-modal-text"
              [(ngModel)]="uploadText"
              placeholder="Start typing…"
              rows="7"
              class="form-control">
            </textarea>
          </div>
          <div class=" d-flex justify-content-start mt-20">
            <a href="javascript:void(0);" (click)="cancelChanges(false)" class="button-control text-color-grey-6" id="images-of-damage-modal-delete">
              <svg class="icon  icon--sm text-color-grey-4">
                <use xlink:href="#trash-bin"></use>
              </svg>
              Delete
            </a>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" (click)="cancelChanges()" class="button button--lg button--secondary">Cancel</a>
          <a href="javascript:void(0);" (click)="saveChanges()" id='save-modal-changes'
          class="button button--lg  button--primary" [attr.disabled]="buttonDisabled ? true : null">Save and Close</a>
        </div>
      </div>

    </div>
  </div>
</div>
